"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
const redux_1 = require("redux");
const console_1 = __importDefault(require("./slices/console"));
const entry_1 = __importDefault(require("./slices/entry"));
const main_1 = __importDefault(require("./slices/main"));
const document_1 = __importDefault(require("./slices/document/document"));
const user_1 = __importDefault(require("./slices/user/user"));
const ui_1 = __importDefault(require("./slices/ui"));
exports.reducers = (0, redux_1.combineReducers)({
    //TODO add more as needed
    mainState: main_1.default,
    consoleState: console_1.default,
    entryState: entry_1.default,
    documentState: document_1.default,
    userState: user_1.default,
    uiState: ui_1.default,
});
